<template>
  <div class="container">
    <!-- 第一行：五个统计卡片 -->
    <div class="stats-row mgb20">
      <el-card shadow="hover" class="stats-card" :body-style="{ padding: '0px' }">
        <div class="grid-content grid-con-4">
          <i class="el-icon-reading grid-con-icon"></i>
          <div class="grid-cont-right">
            <div class="grid-num">{{ todayborrow }}</div>
            <div>今日借阅量 (册)</div>
          </div>
        </div>
      </el-card>
      <el-card shadow="hover" class="stats-card" :body-style="{ padding: '0px' }">
        <div class="grid-content grid-con-5">
          <i class="el-icon-s-marketing grid-con-icon"></i>
          <div class="grid-cont-right">
            <div class="grid-num">{{ todayreturn }}</div>
            <div>今日归还量 (册)</div>
          </div>
        </div>
      </el-card>
      <el-card shadow="hover" class="stats-card" :body-style="{ padding: '0px' }">
        <div class="grid-content grid-con-1">
          <i class="el-icon-notebook-1 grid-con-icon"></i>
          <div class="grid-cont-right">
            <div class="grid-num">{{ totalbookscount }}</div>
            <div>馆藏总量</div>
          </div>
        </div>
      </el-card>
      <el-card shadow="hover" class="stats-card" :body-style="{ padding: '0px' }">
        <div class="grid-content grid-con-2">
          <i class="el-icon-view grid-con-icon"></i>
          <div class="grid-cont-right">
            <div class="grid-num">{{ totalborrow }}</div>
            <div>累计借阅</div>
          </div>
        </div>
      </el-card>
      <el-card shadow="hover" class="stats-card" :body-style="{ padding: '0px' }">
        <div class="grid-content grid-con-3">
          <i class="el-icon-finished grid-con-icon"></i>
          <div class="grid-cont-right">
            <div class="grid-num">{{ totalreturn }}</div>
            <div>累计归还</div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 第二行：饼图和折线图 -->
    <el-row :gutter="20" class="mgb20">
      <el-col :span="12">
        <el-card shadow="hover" style="height: 400px; display: flex; flex-direction: column;">
          <div style="display: flex; align-items: center;">
            <img
                src="@/assets/img/book1.png"
                class="user-avator1"
                alt
                style="width: 40px; height: 40px; margin-right: 10px;"
            />
            <span style="font-size: 20px; font-weight: bold;">五大类馆藏占比</span>
          </div>
          <div id="pieChart" style="flex-grow: 1; width: 100%; height: 340px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover" style="height: 400px;">
          <schart
              ref="line"
              class="schart"
              canvasId="trends"
              :options="options"
              v-loading="trendload"
          ></schart>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第三行：小组积分和个人积分 -->
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card shadow="hover">
          <div id="rankClass" style="width: 100%; height: 360px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <schart
              ref="bar"
              class="schart"
              canvasId="student"
              :options="options2"
          ></schart>
        </el-card>
      </el-col>
    </el-row>
    <change-password></change-password>
  </div>
</template>

<script>
import Schart from "vue-schart";
import * as echarts from "echarts";
import changePassword from "@/components/changePassword";
import { ElMessage } from "element-plus";
import {BASE_URL} from "@/utils/constants";
export default {
  name: "dashboard",
  data() {
    return {
      image: null,
      todayborrow: 0,
      todayreturn: 0,
      monthborrow: 0,
      monthreturn: 0,
      totalbookscount: 0,
      totalborrow: 0,
      totalreturn: 0,
      trendload: true,
      name: localStorage.getItem("username"),
      bookTypeData: [], // 存储五大类数据

      // ECharts 实例变量
      rankClassChart: null, // 声明一个变量来保存 ECharts 实例
      pieChartInstance: null, // 声明一个变量来保存饼图实例

      options1: {
        color: ["rgb(45, 140, 240)"],
        title: {
          text: "小组积分排行",
          left: "center",
        },
        legend: {
          data: ["小组积分"],
          left: "center",
          top: "10%",
        },
        grid: {
          top: "25%",
        },
        xAxis: {
          type: "category",
          data: ["暂无小组积分"],
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 10,
        },
        series: [
          {
            name: "小组积分",
            data: [],
            type: "bar",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "rgb(45, 140, 240)",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      },
      options: {
        type: "line",
        title: {
          text: "借还趋势",
        },
        labels: ["没人借还"],
        datasets: [
          {
            label: "借阅",
            data: [0],
            fillColor: "rgb(88,189,157)",
          },
          {
            label: "归还",
            data: [0],
            fillColor: "rgb(107,160,236)",
          },
        ],
      },
      options2: {
        type: "bar",
        title: {
          text: "个人积分排名",
        },
        xRorate: 0,
        labels: ["没有人有积分"],
        datasets: [
          {
            label: "个人积分",
            data: [0],
            fillColor: "rgb(45, 140, 240)",
          },
        ],
      },
    };
  },
  components: {
    Schart,
    changePassword,
  },
  mounted() {
    // 在这里初始化 ECharts 实例，但在数据获取之后再设置选项
    this.rankClassChart = echarts.init(document.getElementById("rankClass"));
    this.pieChartInstance = echarts.init(document.getElementById("pieChart"));

    // 调用数据获取方法
    this.totalbooks(); // 这个方法更新 totalbookscount，用于饼图的中心文本
    this.fetchBookTypeData(); // 获取饼图数据
    this.classranking(); // 获取小组积分排行数据
    this.studentranking(); // 获取个人积分排名数据 (Schart)
    this.dotrend(); // 获取借还趋势数据 (Schart)

    var path = localStorage.getItem("active");
    if (path) {
      this.$router.push(path);
      localStorage.removeItem("active");
    }
  },
  watch: {
    // 监听 options1 的变化并更新图表
    options1: {
      handler(newVal) {
        if (this.rankClassChart) {
          this.rankClassChart.setOption(newVal);
        }
      },
      deep: true,
    },
    // 监听 bookTypeData 的变化并更新饼图
    bookTypeData: {
      handler() {
        this.initPieChart(); // 当 bookTypeData 更新时，重新渲染饼图
      },
      deep: true,
    },
    // 监听 totalbookscount 的变化，以便更新饼图中的图形文本
    totalbookscount: {
      handler() {
        this.initPieChart(); // 当 totalbookscount 变化时，重新渲染饼图
      },
      deep: true,
    },
  },
  created() {
    // 这些方法在这里调用，以确保数据尽早被获取。
    // 然而，图表本身的渲染在 mounted/watch 中进行。
    this.monthborrowed();
    this.monthreturned();
    this.todayborrowed();
    this.todayreturned();
    this.totalborrowed();
    this.totalreturned();
  },
  methods: {
    // 获取图书分类数据
    fetchBookTypeData() {
      const search = {
        IsCLC: true, // 默认使用中图法
      };

      this.$axios({
        url: BASE_URL + "organizations/booktypescount",
        method: "post",
        data: JSON.stringify(search),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.processBookTypeData(res.data.msg); // 处理数据并更新 bookTypeData
        } else {
          ElMessage.error("获取图书分类数据失败");
        }
      }).catch(() => {
        // ElMessage.error("请求失败，请检查网络");
        ElMessage.error(res.data.msg);
      });
    },
    // 处理五大类数据
    processBookTypeData(data) {
      const aggregated = {
        A: { StrBookTypeName: "A", StrBookTypeZH: "马克思主义、列宁主义、毛泽东思想、邓小平理论", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
        B: { StrBookTypeName: "B", StrBookTypeZH: "哲学、宗教", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
        "C-K": { StrBookTypeName: "C-K", StrBookTypeZH: "社会科学总论", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
        "N-X": { StrBookTypeName: "N-X", StrBookTypeZH: "自然科学", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
        Z: { StrBookTypeName: "Z", StrBookTypeZH: "综合性图书", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
      };

      // 遍历数据并聚合
      data.forEach((item) => {
        if (!item.StrBookTypeName) return;

        const letter = item.StrBookTypeName.trim().toUpperCase();
        if (letter === "A") {
          aggregated.A.TotalISBN += Number(item.TotalISBN);
          aggregated.A.TotalCount += Number(item.TotalCount);
          aggregated.A.CostCount += Number(item.CostCount);
        } else if (letter === "B") {
          aggregated.B.TotalISBN += Number(item.TotalISBN);
          aggregated.B.TotalCount += Number(item.TotalCount);
          aggregated.B.CostCount += Number(item.CostCount);
        } else if (letter >= "C" && letter <= "K") {
          aggregated["C-K"].TotalISBN += Number(item.TotalISBN);
          aggregated["C-K"].TotalCount += Number(item.TotalCount);
          aggregated["C-K"].CostCount += Number(item.CostCount);
        } else if (letter >= "N" && letter <= "X") {
          aggregated["N-X"].TotalISBN += Number(item.TotalISBN);
          aggregated["N-X"].TotalCount += Number(item.TotalCount);
          aggregated["N-X"].CostCount += Number(item.CostCount);
        } else if (letter === "Z") {
          aggregated.Z.TotalISBN += Number(item.TotalISBN);
          aggregated.Z.TotalCount += Number(item.TotalCount);
          aggregated.Z.CostCount += Number(item.CostCount);
        }
      });

      // 计算总册数
      const totalCountAll = Object.values(aggregated).reduce((sum, cat) => sum + cat.TotalCount, 0);

      // 计算百分比并格式化 CostCount
      Object.values(aggregated).forEach((cat) => {
        cat.Percentage = totalCountAll > 0 ? ((cat.TotalCount / totalCountAll) * 100).toFixed(2) : "0.00";
        cat.CostCount = Number(cat.CostCount.toFixed(2));
      });

      // 转换为饼图所需格式，包含分类代码
      this.bookTypeData = Object.values(aggregated).map((cat) => ({
        value: cat.TotalCount,
        name: `${cat.StrBookTypeName}: ${cat.StrBookTypeZH}`, // 拼接分类代码和名称
      }));
    },
    // 初始化饼图
    initPieChart() {
      if (!this.pieChartInstance) {
        this.pieChartInstance = echarts.init(document.getElementById("pieChart"));
      }

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)", // 显示分类代码、名称、值和百分比
        },
        legend: {
          orient: "vertical",
          left: "5%",
          top: "10%", // 保持顶部起始位置
          width: 200, // 分配更多图例宽度
          itemGap: 30, // 增大的上下间距
          padding: [10, 10], // 内边距
          textStyle: {
            fontSize: 13,
            width: 180, // 增大文本宽度
            // overflow: "truncate", // 可以取消注释以截断长文本
          },
          formatter: (name) => name, // 保持完整名称显示
        },
        graphic: {
          type: "text",
          left: "57%",
          top: "middle",
          style: {
            text: `馆藏量\n${this.totalbookscount}`,
            textAlign: "center",
            fill: "#000",
            fontSize: 14,
          },
        },
        series: [
          {
            name: "占比",
            type: "pie",
            radius: ["50%", "80%"],
            center: ["60%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false, // 可设为 true 显示标签
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.bookTypeData.length > 0 ? this.bookTypeData : [
              // 如果 bookTypeData 为空，提供一个简单的占位符数据
              { value: 1, name: "暂无数据" },
            ],
          },
        ],
      };
      this.pieChartInstance.setOption(option, true); // 使用 `true` (notMerge) 确保完全重新绘制
    },
    // 获取封面 (其他辅助方法省略，保持原样)
    img() {
      this.image = localStorage.getItem("schoolimg");
    },
    // 近30天借阅
    monthborrowed() {
      this.$axios({
        url: BASE_URL + "organizations/30daysborrowedcount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.monthborrow = res.data.msg;
      });
    },
    // 近30天归还
    monthreturned() {
      this.$axios({
        url: BASE_URL + "organizations/30daysreturncount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.monthreturn = res.data.msg;
      });
    },
    // 今日借阅
    todayborrowed() {
      this.$axios({
        url: BASE_URL + "organizations/todayborrowedcount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.todayborrow = res.data.msg;
      });
    },
    // 今日归还
    todayreturned() {
      this.$axios({
        url: BASE_URL + "organizations/todayreturncount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.todayreturn = res.data.msg;
      });
    },
    // 馆藏总量
    totalbooks() {
      this.$axios({
        url: BASE_URL + "organizations/totalbookscount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.totalbookscount = res.data.msg;
      });
    },
    // 借阅总量
    totalborrowed() {
      this.$axios({
        url: BASE_URL + "organizations/totalborrowedcount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.totalborrow = res.data.msg;
      });
    },
    // 归还总量
    totalreturned() {
      this.$axios({
        url: BASE_URL + "organizations/totalreturncount",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.totalreturn = res.data.msg;
      });
    },
    // 小组排名
    classranking() {
      this.$axios({
        url: BASE_URL + "organizations/topgroups",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        let a = res.data.msg.length > 6 ? 6 : res.data.msg.length;
        let classrankingdata = [];
        let classrankingname = [];
        for (let i = 0; i < a; i++) {
          classrankingdata[i] = res.data.msg[i].IntIntegral;
          if (a > 4) {
            classrankingname[i] =
                (res.data.msg[i].StrDepartmentName.length > 5
                    ? this.tnString(res.data.msg[i].StrDepartmentName)
                    : res.data.msg[i].StrDepartmentName) +
                "-" +
                (res.data.msg[i].StrName.length > 5
                    ? this.tnString(res.data.msg[i].StrName)
                    : res.data.msg[i].StrName);
          } else {
            classrankingname[i] =
                res.data.msg[i].StrDepartmentName + "-" + res.data.msg[i].StrName;
          }
        }
        this.options1.xAxis.data = classrankingname.length === 0 ? ["暂无小组积分"] : classrankingname;
        this.options1.yAxis.max = classrankingdata.length === 0 ? 10 : null;
        this.options1.series[0].data = classrankingdata;

        // 如果图表已经初始化，在这里直接更新其选项
        if (this.rankClassChart) {
          this.rankClassChart.setOption(this.options1);
        }
      });
    },
    // 字符串换行 (保持原样)
    tnString(str) {
      let newStr = "";
      for (let i = 0; i < str.length; i++) {
        if (i !== 0 && i % 5 === 0) {
          newStr += "\n";
        }
        newStr += str[i];
      }
      return newStr;
    },
    // 个人排名
    studentranking() {
      this.$axios({
        url: BASE_URL + "organizations/topreaders",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        let b = res.data.msg.length > 6 ? 6 : res.data.msg.length;
        let studentrankingdata = [];
        let studentrankingname = [];
        for (let i = 0; i < b; i++) {
          studentrankingdata[i] = res.data.msg[i].IntIntegral;
          studentrankingname[i] = res.data.msg[i].StrName;
        }
        this.options2.labels = studentrankingname;
        this.options2.datasets[0].data = studentrankingdata;
      });
    },
    // 借还趋势
    trend() {
      // 先进行第一个 API 调用 (归还)
      this.$axios({
        url: BASE_URL + "organizations/returntrends",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        let returns = [];
        for (let i = 0; i < 7; i++) {
          returns[6 - i] = res.data.msg[i].number;
        }
        this.options.datasets[1].data = returns; // 更新归还数据
      }).then(() => {
        // 第一个请求完成后，再进行第二个 API 调用 (借阅)
        this.$axios({
          url: BASE_URL + "organizations/borrowtrends",
          method: "get",
          headers: {
            "Content-Type": "application/json",
            dataType: "json",
            Authorization: localStorage.getItem("token"),
          },
        }).then((res) => {
          let days = [];
          let borrows = [];
          for (let i = 0; i < 7; i++) {
            days[6 - i] = res.data.msg[i].id;
            borrows[6 - i] = res.data.msg[i].number;
          }
          this.options.labels = days;
          this.options.datasets[0].data = borrows; // 更新借阅数据
        }).finally(() => {
          this.trendload = false; // 在两个 API 调用都完成后，将加载状态设为 false
        });
      });
    },
    dotrend() {
      this.trendload = true; // 开始获取数据时，将加载状态设为 true
      this.trend();
    },
  },
  // 在组件销毁前，确保销毁 ECharts 实例，防止内存泄漏
  beforeUnmount() {
    if (this.rankClassChart) {
      this.rankClassChart.dispose();
      this.rankClassChart = null;
    }
    if (this.pieChartInstance) {
      this.pieChartInstance.dispose();
      this.pieChartInstance = null;
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.grid-content {
  display: flex;
  align-items: center;
  height: 100px;
}
.grid-cont-right {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
}
.grid-num {
  font-size: 30px;
  font-weight: bold;
}
.grid-con-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}
.grid-con-1 .grid-con-icon {
  background: rgb(45, 140, 240);
}
.grid-con-1 .grid-num {
  color: rgb(45, 140, 240);
}
.grid-con-2 .grid-con-icon {
  background: rgb(100, 213, 114);
}
.grid-con-2 .grid-num {
  color: rgb(45, 140, 240);
}
.grid-con-3 .grid-con-icon {
  background: rgb(242, 94, 67);
}
.grid-con-3 .grid-num {
  color: rgb(242, 94, 67);
}
.grid-con-4 .grid-con-icon {
  background: rgb(214, 189, 24);
}
.grid-con-4 .grid-num {
  color: rgb(45, 140, 240);
}
.grid-con-5 .grid-con-icon {
  background: rgb(10, 114, 152);
}
.grid-con-5 .grid-num {
  color: rgb(45, 140, 240);
}
.user-info {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
}
.user-avator {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.user-avator1 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.user-info-cont {
  padding-left: 50px;
  flex: 1;
  font-size: 14px;
  color: #999;
}
.user-info-cont div:first-child {
  font-size: 30px;
  color: #222;
}
.user-info-list {
  font-size: 14px;
  color: #999;
  line-height: 25px;
}
.user-info-list span {
  margin-left: 70px;
}
.mgb20 {
  margin-bottom: 20px;
}
.todo-item {
  font-size: 14px;
}
.todo-item-del {
  text-decoration: line-through;
  color: #999;
}
.schart {
  width: 100%;
  height: 360px; /* 调整以适应卡片高度 */
}

/* 新增样式：统计卡片行 */
.stats-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: space-between;
}
.stats-card {
  flex: 1;
  min-width: 0;
}

/* 响应式支持 */
@media (max-width: 768px) {
  .stats-row {
    flex-wrap: wrap;
  }
  .stats-card {
    flex: 0 0 100%;
    margin-bottom: 10px;
  }
  .el-col {
    width: 100%; /* 图表垂直排列 */
    margin-bottom: 20px;
  }
}
</style>

